import { FC, useRef } from 'react'
import Link from 'next/link'
import Tag from './Tag'
import { IconClock, IconRefresh } from '@tabler/icons'
import Image from '@/components/Image'
import { ArticleTag } from 'src/api/types'

export type Props = {
  id: string
  eyeCatching: {
    url: string
  },
  title: string
  description: string
  revisedAt?: string
  readTime: string
  tags: ArticleTag[]
  url: string
}

const Component: FC<Props> = ({ title, eyeCatching, description, revisedAt, readTime, url, tags }) => {
  const size = 'w=304&h=171'

  const ref = useRef<HTMLAnchorElement | null>(null)
  const onClickCard = () => {
    if (ref.current != null) {
      ref.current.click()
    }
  }

  return (
    <>
      <div
        onClick={onClickCard}
        className="w-[320px] xs:w-[342px] xs:h-[406px] md:w-[292px] md:h-[347px]
        p-[19px] xl:w-[250px] xl:h-[298px] rounded-[4px] md:p-[14px] shadow hover:shadow-md bg-white hover:border-white hover:opacity-90 max-w-full"
      >
        <div className="rounded-[4px] aspect-video w-full">
          <Image url={eyeCatching.url} size={size} />
        </div>

        <Link href={url} prefetch={false}>
          <a
            ref={ref}
            className="line-clamp-2 text-xl md:text-base mt-2 font-semibold hover:text-primary-500 inline-block"
          >
            {title}
          </a>
        </Link>

        <section className="flex gap-2 my-4 md:my-1 overflow-hidden">
          {tags.map((tag) => (
            <Tag key={tag.id} name={tag.name} />
          ))}
        </section>

        <p className="text-base md:text-xs md:leading-tight line-clamp-2 my-2">{description}</p>

        <div className="flex gap-2 text-xs mt-1 text-gray-600">
          <div className="flex gap-1 items-center">
            <IconRefresh width="12" height="12" />
            <p>{revisedAt}</p>
          </div>
          <div className="flex gap-1 items-center">
            <IconClock width="12" height="12" />
            <p>{readTime}</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Component
